"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFavorite = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var favoritesSlice_1 = require("../redux/slice/favoritesSlice");
var selectors_1 = require("../redux/selectors");
var useFavorite = function (auto) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var carFavoriteList = (0, react_redux_1.useSelector)(selectors_1.favoritesSelector).favoritesList;
    var _a = react_1.default.useState(Boolean(carFavoriteList.find(function (car) { return car.id === auto.id; }))), isFavorite = _a[0], setIsFavorite = _a[1];
    react_1.default.useEffect(function () {
        setIsFavorite(Boolean(carFavoriteList.find(function (car) { return car.id === auto.id; })));
    }, [carFavoriteList.length]);
    var removeFavorites = function () {
        dispatch((0, favoritesSlice_1.removeFromFavorites)(auto.id));
    };
    var addFavorites = function () {
        console.log('useAddtoFavrotie');
        dispatch((0, favoritesSlice_1.addToFavorites)(auto));
    };
    return { isFavorite: isFavorite, removeFavorites: removeFavorites, addFavorites: addFavorites };
};
exports.useFavorite = useFavorite;
